import * as actions from './stats-action.actions';

import { createFeature, createReducer, on } from '@ngrx/store';

import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';

export interface State {
    error: SharedErrorObjectI | null;
    loaded: boolean;
    loading: boolean;
    data: any;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null
};

export default createFeature({
    name: 'statsAction',
    reducer: createReducer(
    initialState,
    on(actions.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(actions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(actions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
    })),
    on(actions.load, (state: State, { }): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
)}
);
